export default __webpack_public_path__ + "static/media/Pelvic_Set_Up_Male.dc8ef7bc.png";